import AppRoutes from "./routes/AppRoutes";
import { CitiesProvider } from "./contexts/CitiesProvider";

function App() {
  return (
    <CitiesProvider>
      <AppRoutes />
    </CitiesProvider>
  );
}

export default App;
